import { render, staticRenderFns } from "./IAShipParticular.vue?vue&type=template&id=aefaed52&scoped=true&"
import script from "./IAShipParticular.vue?vue&type=script&lang=js&"
export * from "./IAShipParticular.vue?vue&type=script&lang=js&"
import style0 from "./IAShipParticular.vue?vue&type=style&index=0&id=aefaed52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefaed52",
  null
  
)

export default component.exports